import React from 'react';

import { ExperimentsNavigation } from 'client/app/apps/experiments/ExperimentsNavigation';
import { Tutorials } from 'client/app/apps/experiments/Tutorials/Tutorials';

export default function ExampleGalleryScreen() {
  return (
    <ExperimentsNavigation title="Example Gallery">
      <Tutorials />
    </ExperimentsNavigation>
  );
}
